import React from 'react'
import {useTranslation} from 'react-i18next'
import {useInjection} from 'dna-react-ioc'
import {PayByLinkSendMessageStoreSymbol} from '@/pages/PayByLink'
import {ModalFormFooter} from '@/components'
import {SendMessageStore} from '@/stores'
import {DownloadPdfFooterProps} from './props'

export const DownloadPdfFooter: React.FC<DownloadPdfFooterProps> = ({formId, form, closeModal}) => {
    const {t} = useTranslation()
    const store = useInjection<SendMessageStore>(PayByLinkSendMessageStoreSymbol)
    const {isLoading, closeLinkDetailsModal} = store

    const onCancel = () => {
        form.resetFields()
        closeLinkDetailsModal()
        closeModal()
    }

    return (
        <ModalFormFooter
            formId={formId}
            okText={t('DownloadPdfForm.downloadQr')}
            confirmLoading={isLoading}
            onCancel={onCancel}
        />
    )
}
